// components/CashbackModal.js
import React from "react";

export default function CashbackModal({ offer, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-lg p-6 max-w-md w-full relative bg-white shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          aria-label="Close cashback popup"
          type="button"
        >
          ❌
        </button>
        <h2 className="text-center text-xl font-semibold mb-4">
          Cashback Offer Details
        </h2>
        <p className="mb-2 font-semibold">{offer.productName}</p>
        <p className="mb-2">{offer.vendor}</p>
        <p className="mb-4">
          Cashback Amount: <span className="font-bold">${offer.cashbackAmount}</span>
        </p>
        {offer.cashbackInstructions && (
          <p className="text-sm text-gray-600 whitespace-pre-line">
            {offer.cashbackInstructions}
          </p>
        )}
      </div>
    </div>
  );
}
